import { useState } from "react";
import Button from "../../Shared/Button/Button";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import InputBox from "./InputBox";
import InputOption from "./InputOption";
import InputSelect from "./InputSelect";

const CreateListingFilters = () => {
  const [subCategory, setSubCategory] = useState(true);
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Create Listing Filters"} dropdown={false} />
      <p className="mt-[30px] mb-5 font-pop text-base font-medium text-inputBorder">
        Filters allow you to screen listings as they are listed on this site. As
        soon as a listing placed that meets your filter criteria, you will be
        immediately notified by email of the listing. To implement a new listing
        filter, please select the category you would like the system to screen.
        Next indicate whether or not you would also like to screen that
        category’s subcategories as well. Lastly, enter the search terms (or
        terms) you want to screen the new listing for.
      </p>
      <div className="mx-auto mb-[60px] max-w-[596px] border border-inputBorder px-20 pb-20 pt-10">
        <InputSelect
          title="Categories to Search"
          placeholder="All Categories"
        />
        <InputOption
          title="Search subcategories also"
          onClick={setSubCategory}
          subCategory={subCategory}
        />
        <InputBox title="Terms to screens for" placeholder="Bmw 118l" />
        <InputSelect title="Province" placeholder="Goteng" />
        <InputSelect title="City" placeholder="Pretoria" />
        <Button
          variant="primary"
          text="Save filter"
          className="mt-9 !w-full pt-4 pb-4 !text-2xl"
        />
      </div>
    </div>
  );
};

export default CreateListingFilters;
